import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../pages/styles.css'; // Ajuste para o caminho correto do CSS
import ThemeToggle from '../components/ThemeToggle';
import ReactGA from 'react-ga4';
import { trackSalesPageView, trackPurchaseClick } from '../utils/analytics';

// Importe as imagens necessárias
import premiumImage from '../images/vip-premium.jpeg'; // Substitua pelo caminho real da imagem VIP Premium
import dropsDayImage from '../images/drops-day.jpeg'; // Substitua pelo caminho real da imagem Drops Day
import logoDropsDay from '../images/Logo_dropsDay.png'; // Logo do aplicativo DropsDay

const SalesPage_pt = () => {
  const navigate = useNavigate();
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Verificar se o modo escuro está ativo
    setIsDarkMode(document.body.classList.contains('dark-theme')); // Use dark-theme como padrão

    try {
      trackSalesPageView();
    } catch (error) {
      console.error("Erro ao rastrear visualização da página:", error);
    }
    
    // Configurar observador para mudanças no modo escuro
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.attributeName === 'class' &&
          mutation.target === document.body
        ) {
          setIsDarkMode(document.body.classList.contains('dark-theme'));
        }
      });
    });
    
    observer.observe(document.body, { attributes: true });
    
    // Efeito de carregamento suave
    setTimeout(() => {
      setIsLoaded(true);
    }, 300);
    
    // Rolar para o topo
    window.scrollTo(0, 0);
    
    return () => {
      observer.disconnect();
    };
  }, []);

  const handleSubscribeMensal = () => {
    try {
      trackPurchaseClick();
    } catch (error) {
      console.error("Erro ao rastrear clique de compra:", error);
    }
    window.location.href = 'https://pay.hotmart.com/E101657077C?off=zxgntn82';
  };

  const handleSubscribeTrimestral = () => {
    try {
      trackPurchaseClick();
    } catch (error) {
      console.error("Erro ao rastrear clique de compra:", error);
    }
    window.location.href = 'https://pay.hotmart.com/E101657077C?off=hkreo8eu';
  };

  const handleSubscribeAnual = () => {
    try {
      trackPurchaseClick();
    } catch (error) {
      console.error("Erro ao rastrear clique de compra:", error);
    }
    window.location.href = 'https://pay.hotmart.com/E101657077C?off=sr5k8dtl';
  };

  const scrollToPlans = () => {
    // Scroll suave até a seção dos planos
    const plansSection = document.getElementById('plans-section');
    if (plansSection) {
      plansSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  return (
    <div className={`page-container ${isDarkMode ? 'dark' : 'light'}`}>
      <ThemeToggle />
      
      <div className={`page-content ${isLoaded ? 'loaded' : ''}`} style={{
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 20px'
      }}>
        {/* Seção Hero */}
        <section className="hero-section" style={{
          background: isDarkMode 
            ? 'linear-gradient(135deg, #1e3a8a, #312e81)' 
            : 'linear-gradient(135deg, #2563eb, #4338ca)',
          padding: '3rem 1.5rem',
          borderRadius: '12px',
          marginBottom: '2.5rem',
          color: 'white',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'radial-gradient(circle at top right, rgba(255,255,255,0.15), transparent)',
            zIndex: 1
          }}></div>
          
          <div style={{ position: 'relative', zIndex: 2 }}>
            <h1 style={{ 
              fontSize: '2.5rem', 
              fontWeight: 'bold',
              marginBottom: '1rem',
              background: 'linear-gradient(to right, #ffffff, #fbbf24)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              textShadow: '0 2px 4px rgba(0,0,0,0.2)'
            }}>
              Desbloqueie Seu Potencial com Acesso Premium por 1 Ano
            </h1>
            
            <p style={{ 
              fontSize: '1.2rem',
              maxWidth: '800px',
              margin: '0 auto 2rem',
              lineHeight: '1.6'
            }}>
              Transforme sua rotina com treinamentos baseados em PNL e Neurociência, acesso completo a todos os conteúdos e sistema de recompensas exclusivo para membros Premium.
            </p>
            
            <button 
              onClick={scrollToPlans}
              style={{
                background: 'linear-gradient(135deg, #fbbf24, #d97706)',
                color: '#000000',
                border: 'none',
                borderRadius: '8px',
                padding: '1rem 1.5rem',
                fontSize: '1.25rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
                transition: 'transform 0.3s, box-shadow 0.3s'
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.3)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.2)';
              }}
            >
              👉 Ver Planos e Escolher o Ideal para Mim
            </button>
          </div>
        </section>
        
        {/* Card Especial - Download do Aplicativo */}
        <section className="app-download-section" style={{
          background: isDarkMode 
            ? 'linear-gradient(135deg, #059669, #047857)' 
            : 'linear-gradient(135deg, #10b981, #059669)',
          borderRadius: '16px',
          padding: '2.5rem 2rem',
          marginBottom: '2.5rem',
          color: 'white',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 8px 25px rgba(16, 185, 129, 0.3)',
          border: '3px solid rgba(255, 255, 255, 0.2)'
        }}>
          {/* Efeito de brilho de fundo */}
          <div style={{
            position: 'absolute',
            top: '-50%',
            left: '-50%',
            width: '200%',
            height: '200%',
            background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
            zIndex: 1,
            animation: 'pulse 3s ease-in-out infinite'
          }}></div>
          
          <div style={{ position: 'relative', zIndex: 2 }}>
            {/* Logo do aplicativo em destaque */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: '1.5rem'
            }}>
              <img 
                src={logoDropsDay} 
                alt="DropsDay App Logo" 
                style={{
                  width: '120px',
                  height: '120px',
                  borderRadius: '24px',
                  boxShadow: '0 8px 25px rgba(0, 0, 0, 0.3)',
                  border: '4px solid rgba(255, 255, 255, 0.8)',
                  animation: 'logoFloat 2s ease-in-out infinite'
                }}
              />
            </div>
            
            <h2 style={{
              fontSize: '2rem',
              fontWeight: 'bold',
              marginBottom: '1rem',
              textShadow: '0 2px 4px rgba(0,0,0,0.3)'
            }}>
              📱 Ainda não tem o App DropsDay?
            </h2>
            
            <p style={{
              fontSize: '1.3rem',
              marginBottom: '2rem',
              maxWidth: '700px',
              margin: '0 auto 2rem',
              lineHeight: '1.6',
              opacity: 0.95
            }}>
              Baixe agora o aplicativo oficial e tenha acesso completo à experiência DropsDay diretamente no seu smartphone!
            </p>
            
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '1rem',
              alignItems: 'center',
              marginBottom: '2rem'
            }}>
              {/* Benefícios do app */}
              <div style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '1rem',
                justifyContent: 'center',
                marginBottom: '1.5rem'
              }}>
                <div style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  padding: '0.8rem 1.2rem',
                  borderRadius: '25px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  🔄 Experiência completa DropsDay
                </div>
                <div style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  padding: '0.8rem 1.2rem',
                  borderRadius: '25px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  📱 Interface otimizada para mobile
                </div>
                <div style={{
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  padding: '0.8rem 1.2rem',
                  borderRadius: '25px',
                  fontSize: '1rem',
                  fontWeight: '600',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem'
                }}>
                  🎯 Notificações personalizadas
                </div>
              </div>
              
              {/* Botão de download */}
              <button 
                onClick={() => window.open('https://apkpure.com/drosday/com.dropsebook.app', '_blank')}
                style={{
                  background: 'linear-gradient(135deg, #ffffff, #f3f4f6)',
                  color: '#047857',
                  border: '3px solid rgba(255, 255, 255, 0.8)',
                  borderRadius: '50px',
                  padding: '1.2rem 2.5rem',
                  fontSize: '1.4rem',
                  fontWeight: 'bold',
                  cursor: 'pointer',
                  boxShadow: '0 8px 25px rgba(0, 0, 0, 0.2)',
                  transition: 'all 0.3s ease',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.8rem',
                  minWidth: '280px'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px) scale(1.05)';
                  e.currentTarget.style.boxShadow = '0 12px 35px rgba(0, 0, 0, 0.3)';
                  e.currentTarget.style.background = 'linear-gradient(135deg, #f9fafb, #ffffff)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0) scale(1)';
                  e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.2)';
                  e.currentTarget.style.background = 'linear-gradient(135deg, #ffffff, #f3f4f6)';
                }}
              >
                📲 Baixar DropsDay App
              </button>
              
              <p style={{
                fontSize: '0.9rem',
                opacity: 0.9,
                fontStyle: 'italic',
                margin: 0
              }}>
                Grátis • Android • Acesso direto aos conteúdos
              </p>
            </div>
          </div>
        </section>
        
        {/* Bloco 1 - Acesso Total aos Treinamentos Premium */}
        <section className="feature-block" style={{
          background: isDarkMode ? '#1f2937' : '#ffffff',
          borderRadius: '12px',
          padding: '2rem',
          marginBottom: '2.5rem',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div style={{
              minWidth: '48px',
              height: '48px',
              borderRadius: '50%',
              background: isDarkMode ? '#374151' : '#f3f4f6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem'
            }}>
              ✨
            </div>
            <h2 style={{
              margin: 0,
              fontSize: '1.8rem',
              color: isDarkMode ? '#e5e7eb' : '#111827',
              fontWeight: 'bold'
            }}>
              Acesso Total aos Treinamentos Premium
            </h2>
          </div>
          
          <div style={{ 
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            gap: '2rem',
            flexWrap: 'wrap',
            justifyContent: 'center',
            maxWidth: '1100px',
            margin: '0 auto'
          }}>
            <div style={{ flex: '1 1 300px', maxWidth: '350px' }}>
              <img 
                src={premiumImage} 
                alt="VIP Premium" 
                style={{
                  width: '100%',
                  maxWidth: '250px',
                  height: 'auto',
                  borderRadius: '8px',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                  margin: '0 auto',
                  display: 'block'
                }}
              />
            </div>
            
            <div style={{ flex: '1 1 300px', maxWidth: '550px' }}>
              <h3 style={{ 
                color: isDarkMode ? '#10b981' : '#059669',
                fontSize: '1.4rem',
                marginTop: 0,
                marginBottom: '1rem'
              }}>
                Tenha acesso completo a todos os treinamentos Premium por 1 ano
              </h3>
              
              <p style={{ 
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                lineHeight: '1.6',
                fontSize: '1.1rem'
              }}>
                Tenha à sua disposição uma biblioteca exclusiva com treinamentos completos sobre superação, produtividade, desenvolvimento emocional e mentalidade de sucesso — tudo baseado em PNL (Programação Neurolinguística) e Neurociência Motivacional.
              </p>
              
              <p style={{ 
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                lineHeight: '1.6',
                fontSize: '1.1rem'
              }}>
                E o melhor: novos conteúdos lançados durante o seu plano estarão automaticamente disponíveis.
              </p>
              
              <p style={{ 
                color: isDarkMode ? '#f9fafb' : '#111827',
                fontWeight: 'bold',
                fontSize: '1.1rem',
                marginTop: '1.5rem'
              }}>
                ✨ Você cresce, aprende e transforma sua realidade por dentro e por fora.
              </p>
            </div>
          </div>
        </section>
        
        {/* Bloco 2 - Acesso Premium ao Drops Day */}
        <section className="feature-block" style={{
          background: isDarkMode ? '#1f2937' : '#ffffff',
          borderRadius: '12px',
          padding: '2rem',
          marginBottom: '2.5rem',
          boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
          display: 'flex',
          flexDirection: 'column',
          gap: '1.5rem'
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div style={{
              minWidth: '48px',
              height: '48px',
              borderRadius: '50%',
              background: isDarkMode ? '#374151' : '#f3f4f6',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '1.5rem'
            }}>
              🔄
            </div>
            <h2 style={{
              margin: 0,
              fontSize: '1.8rem',
              color: isDarkMode ? '#e5e7eb' : '#111827',
              fontWeight: 'bold'
            }}>
               Acesso Premium ao Drops Day
            </h2>
          </div>
          
          <div style={{ 
            display: 'flex',
            flexDirection: 'row-reverse', // Inverte a ordem para variar o layout
            alignItems: 'center',
            gap: '2rem',
            flexWrap: 'wrap',
            justifyContent: 'center',
            maxWidth: '1100px',
            margin: '0 auto'
          }}>
            <div style={{ flex: '1 1 300px', maxWidth: '350px' }}>
              <img 
                src={dropsDayImage} 
                alt="Drops Day" 
                style={{
                  width: '100%',
                  maxWidth: '250px',
                  height: 'auto',
                  borderRadius: '8px',
                  boxShadow: '0 4px 10px rgba(0, 0, 0, 0.15)',
                  margin: '0 auto',
                  display: 'block'
                }}
              />
            </div>
            
            <div style={{ flex: '1 1 300px', maxWidth: '550px' }}>
              <h3 style={{ 
                color: isDarkMode ? '#10b981' : '#059669',
                fontSize: '1.4rem',
                marginTop: 0,
                marginBottom: '1rem'
              }}>
                Receba novos conteúdos motivacionais todos os dias
              </h3>
              
              <p style={{ 
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                lineHeight: '1.6',
                fontSize: '1.1rem'
              }}>
                O Drops Day é uma jornada terapêutica interativa com técnicas validadas pela ciência, que atua diretamente nas suas emoções do dia. Com o acesso Premium, você desbloqueia:
              </p>
              
              <ul style={{ 
                color: isDarkMode ? '#d1d5db' : '#4b5563',
                lineHeight: '1.8',
                fontSize: '1.1rem',
                paddingLeft: '1.5rem'
              }}>
                <li>Temas exclusivos</li>
                <li>Vídeos motivacionais profundos</li>
                <li>Novo conteúdo diário por 1 ano</li>
                <li>Acesso total aos temas especiais de prosperidade, foco, disciplina, liderança, etc.</li>
              </ul>
              
              <p style={{ 
                color: isDarkMode ? '#f9fafb' : '#111827',
                fontWeight: 'bold',
                fontSize: '1.1rem',
                marginTop: '1.5rem'
              }}>
                💡 O seu dia começa com clareza, propósito e motivação — todos os dias.
              </p>
            </div>
          </div>
        </section>
        
        {/* Rodapé com chamada final */}
        <section style={{
          background: isDarkMode 
            ? 'linear-gradient(135deg, #1e3a8a, #312e81)' 
            : 'linear-gradient(135deg, #2563eb, #4338ca)',
          borderRadius: '12px',
          padding: '2rem',
          textAlign: 'center',
          color: 'white'
        }}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '2rem'
          }}>
            <h2 style={{ 
              fontSize: '1.8rem',
              fontWeight: 'bold',
              maxWidth: '800px',
              margin: '0 auto'
            }}>
              Tudo isso por um único investimento anual — que se paga com conhecimento, transformação e recompensas reais.
            </h2>
            
            {/* Indicador visual de etapas */}
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              gap: '1rem',
              flexWrap: 'wrap',
              margin: '1rem 0 2rem'
            }}>
              <div style={{
                padding: '0.5rem 1rem',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                borderRadius: '20px',
                fontSize: '0.9rem'
              }}>
                🧠 Treinamento
              </div>
              <div style={{
                padding: '0.5rem 1rem',
                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                borderRadius: '20px',
                fontSize: '0.9rem'
              }}>
                🔁 Drops Day
              </div>
            </div>
            
            {/* Cards de Planos de Assinatura */}
            <div id="plans-section" style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '1.5rem',
              maxWidth: '900px',
              width: '100%',
              margin: '0 auto'
            }}>
              {/* Plano Mensal */}
              <div style={{
                background: isDarkMode ? '#374151' : 'rgba(255, 255, 255, 0.95)',
                borderRadius: '12px',
                padding: '1.5rem',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s, box-shadow 0.3s',
                cursor: 'pointer'
              }}
              onClick={handleSubscribeMensal}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
              }}
              >
                <h3 style={{
                  color: isDarkMode ? '#f3f4f6' : '#111827',
                  fontSize: '1.3rem',
                  fontWeight: 'bold',
                  margin: '0 0 0.5rem 0'
                }}>
                  Plano Mensal
                </h3>
                <div style={{
                  color: isDarkMode ? '#10b981' : '#059669',
                  fontSize: '1.8rem',
                  fontWeight: 'bold',
                  margin: '1rem 0'
                }}>
                  R$ 6,99
                  <span style={{
                    fontSize: '1rem',
                    color: isDarkMode ? '#9ca3af' : '#6b7280'
                  }}> / mês</span>
                </div>
                <div style={{
                  background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                  color: 'white',
                  padding: '0.8rem 1.5rem',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  fontSize: '1rem'
                }}>
                  Assinar Agora
                </div>
              </div>

              {/* Plano Trimestral */}
              <div style={{
                background: isDarkMode ? '#374151' : 'rgba(255, 255, 255, 0.95)',
                borderRadius: '12px',
                padding: '1.5rem',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s, box-shadow 0.3s',
                cursor: 'pointer',
                border: '2px solid #fbbf24',
                position: 'relative'
              }}
              onClick={handleSubscribeTrimestral}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
              }}
              >
                <div style={{
                  position: 'absolute',
                  top: '-10px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  background: '#fbbf24',
                  color: '#000',
                  padding: '0.3rem 0.8rem',
                  borderRadius: '12px',
                  fontSize: '0.8rem',
                  fontWeight: 'bold'
                }}>
                  POPULAR
                </div>
                <h3 style={{
                  color: isDarkMode ? '#f3f4f6' : '#111827',
                  fontSize: '1.3rem',
                  fontWeight: 'bold',
                  margin: '0.5rem 0 0.5rem 0'
                }}>
                  Plano Trimestral
                </h3>
                <div style={{
                  color: isDarkMode ? '#10b981' : '#059669',
                  fontSize: '1.8rem',
                  fontWeight: 'bold',
                  margin: '1rem 0'
                }}>
                  R$ 17,99
                  <span style={{
                    fontSize: '1rem',
                    color: isDarkMode ? '#9ca3af' : '#6b7280'
                  }}> / trimestre</span>
                </div>
                <div style={{
                  fontSize: '0.9rem',
                  color: isDarkMode ? '#9ca3af' : '#6b7280',
                  marginBottom: '1rem'
                }}>
                  Economia de R$ 2,98
                </div>
                <div style={{
                  background: 'linear-gradient(135deg, #fbbf24, #d97706)',
                  color: '#000',
                  padding: '0.8rem 1.5rem',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  fontSize: '1rem'
                }}>
                  Assinar Agora
                </div>
              </div>

              {/* Plano Anual */}
              <div style={{
                background: isDarkMode ? '#374151' : 'rgba(255, 255, 255, 0.95)',
                borderRadius: '12px',
                padding: '1.5rem',
                textAlign: 'center',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)',
                transition: 'transform 0.3s, box-shadow 0.3s',
                cursor: 'pointer'
              }}
              onClick={handleSubscribeAnual}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.2)';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 4px 15px rgba(0, 0, 0, 0.1)';
              }}
              >
                <h3 style={{
                  color: isDarkMode ? '#f3f4f6' : '#111827',
                  fontSize: '1.3rem',
                  fontWeight: 'bold',
                  margin: '0 0 0.5rem 0'
                }}>
                  Plano Anual
                </h3>
                <div style={{
                  color: isDarkMode ? '#10b981' : '#059669',
                  fontSize: '1.8rem',
                  fontWeight: 'bold',
                  margin: '1rem 0'
                }}>
                  R$ 67,00
                  <span style={{
                    fontSize: '1rem',
                    color: isDarkMode ? '#9ca3af' : '#6b7280'
                  }}> / ano</span>
                </div>
                <div style={{
                  fontSize: '0.9rem',
                  color: isDarkMode ? '#9ca3af' : '#6b7280',
                  marginBottom: '1rem'
                }}>
                  Economia de R$ 16,88
                </div>
                <div style={{
                  background: 'linear-gradient(135deg, #10b981, #059669)',
                  color: 'white',
                  padding: '0.8rem 1.5rem',
                  borderRadius: '8px',
                  fontWeight: 'bold',
                  fontSize: '1rem'
                }}>
                  Assinar Agora
                </div>
              </div>
            </div>
            
            <p style={{ fontSize: '0.9rem', opacity: 0.8, maxWidth: '600px', margin: '0 auto' }}>
              © {new Date().getFullYear()} Tool for Victory. Todos os direitos reservados. Ao assinar, você concorda com nossos termos de serviço e política de privacidade.
            </p>
          </div>
        </section>
      </div>
      
      {/* Estilos CSS para animações */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @keyframes logoFloat {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-10px); }
          }
          
          @keyframes pulse {
            0%, 100% { opacity: 0.8; }
            50% { opacity: 1; }
          }
          
          .app-download-section {
            animation: slideInUp 0.8s ease-out;
          }
          
          @keyframes slideInUp {
            from {
              opacity: 0;
              transform: translateY(30px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
          
          /* Responsividade para mobile */
          @media (max-width: 768px) {
            .app-download-section {
              padding: 1.5rem 1rem !important;
            }
            
            .app-download-section h2 {
              font-size: 1.5rem !important;
            }
            
            .app-download-section p {
              font-size: 1.1rem !important;
            }
            
            .app-download-section img {
              width: 80px !important;
              height: 80px !important;
            }
            
            .app-download-section button {
              font-size: 1.2rem !important;
              padding: 1rem 2rem !important;
            }
          }
        `
      }} />
    </div>
  );
};

export default SalesPage_pt;
